import React, { useEffect, useState } from 'react';
import { Box, Typography, Tabs, Tab } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import {
  fetchTestRuns,
  fetchTestRun,
  cleanupTestProgram,
  fetchTestSpeed,
  updateTestSpeed,
} from '../../../redux/actions/testManagementAction';
import TestRunList from './TestRunList';
import TestRunDetail from './TestRunDetail';
import CommunityLoader from './CommunityLoader';
import { useStyles } from './style';

const TestManagement: React.FC = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { testRuns, currentRun, loading, cleaningUp, speedMultiplier } = useSelector(
    (state: RootState) => state.testManagementReducer
  );

  const [activeTab, setActiveTab] = useState(0);
  const [selectedRunId, setSelectedRunId] = useState<string | null>(null);

  useEffect(() => {
    dispatch(fetchTestRuns());
    dispatch(fetchTestSpeed());
  }, [dispatch]);

  const handleViewRun = (runId: string) => {
    setSelectedRunId(runId);
    dispatch(fetchTestRun(runId));
  };

  const handleBack = () => {
    setSelectedRunId(null);
  };

  const handleCleanup = (programId: string, runId: string) => {
    if (window.confirm('Are you sure you want to cleanup this test run? This will delete all test data.')) {
      dispatch(cleanupTestProgram(programId, runId));
    }
  };

  const handleRefresh = () => {
    dispatch(fetchTestRuns());
  };

  const handleSpeedChange = (speed: number) => {
    dispatch(updateTestSpeed(speed));
  };

  return (
    <Box className={classes.container}>
      <Box className={classes.header}>
        <Typography className={classes.title}>Test Management</Typography>
      </Box>

      {selectedRunId && currentRun ? (
        <TestRunDetail
          run={currentRun}
          onBack={handleBack}
          onCleanup={handleCleanup}
          cleaningUp={cleaningUp}
        />
      ) : (
        <>
          <Tabs
            value={activeTab}
            onChange={(_, val) => setActiveTab(val)}
            indicatorColor="primary"
            textColor="primary"
            style={{ marginBottom: 16 }}
          >
            <Tab label="Test Runs" />
            <Tab label="Community Loader" />
          </Tabs>

          {activeTab === 0 && (
            <TestRunList
              testRuns={testRuns}
              loading={loading}
              cleaningUp={cleaningUp}
              onViewRun={handleViewRun}
              onCleanup={handleCleanup}
              onRefresh={handleRefresh}
            />
          )}

          {activeTab === 1 && (
            <CommunityLoader
              speedMultiplier={speedMultiplier}
              onSpeedChange={handleSpeedChange}
            />
          )}
        </>
      )}
    </Box>
  );
};

export default TestManagement;
